/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */

import React from 'react';
import PropTypes from 'prop-types';
import { isBoolean, isNumber, isString } from 'lodash';
import { useTranslation } from 'react-i18next';
import ViewableJSONDisplay from './ViewableJSONDisplay';

function AsyncapiBindings({ bindings }) {
  const { t } = useTranslation();

  if (bindings.length === 0) {
    return null;
  }
  const bindingName = Object.keys(bindings)[0];
  const bindingInfo = bindings[bindingName].json();
  return (
    Object.keys(bindingInfo)?.length > 0 && (
      <div className="bindingContainer">
        <h6>{t('binding_details')}</h6>
        <div className="bindingTable">
          {Object.keys(bindingInfo).map((binding, index) => (
            <div className="keyValueDisplay" key={`${binding + index}`}>
              <div className="key bindingKey">{binding}</div>
              {(isString(bindingInfo[binding]) || isNumber(bindingInfo[binding]) || isBoolean(bindingInfo[binding])) && (
                <div className="value bindingValue">{String(bindingInfo[binding])}</div>
              )}
              {!isString(bindingInfo[binding]) && !isNumber(bindingInfo[binding]) && !isBoolean(bindingInfo[binding]) && (
                <div className="value bindingValue">
                  <ViewableJSONDisplay content={bindingInfo[binding]} />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    )
  );
}

AsyncapiBindings.propTypes = {
  bindings: PropTypes.object
};

export default AsyncapiBindings;
